import ky from "ky";


/**
 * httpError returns a promise that accepts an HTTP error response and resolves to a
 * standardised error object. The error object contains the HTTP status code and text and
 * a data property that will be an object if the server returned JSON or a string.
 *
 * @param error
 * @returns {Promise<unknown>}
 */
export function httpError(error) {

    return new Promise((resolve) => {

        if (error instanceof ky.HTTPError) {
            //console.log('error type is ky.HTTPError')
            // We got a response from the server
            // Read the body to see if the server returned anything
            error.response.text().then(body => {
                // Convert the body to json.  If it fails, fall back to the string
                let data;
                try {
                    data = JSON.parse(body)
                }
                catch {
                    data = body;
                }
                //console.log('httpError: error.response.status =', error.response.status)
                //console.log('httpError: error.response.statusText =', error.response.statusText)
                //console.log('httpError: data =', data)

                resolve({
                    status: error.response.status,
                    statusText: error.response.statusText,
                    data
                })
            })

        } else if (error instanceof ky.TimeoutError) {
            // We timed out
            resolve({status: 0, statusText: 'The request timed out', data: null})

        } else {
            // It's a low level error. Networking issue?
            //console.log('httpError: unrecognised error type. error =', error);
            resolve( {status: 0, statusText: 'Check your internet connection', data: null})
        }
    })

}

const exportedObject = {httpError}

export default exportedObject;